<template>
  <v-container id="main" fluid class="pt-0">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="7"
        class="pa-0 d-flex justify-center align-center flex-column"
        style="background-color: #161e3b; height: 85vh"
      >
        <h1 class="white--text text-center" style="font-size: 4rem">
          UVAL <span style="font-weight: 300">es tu lugar</span>
        </h1>
        <v-divider width="100px" dark></v-divider>
        <br />
        <h3 class="white--text mb-0 mx-5 text-center">
          Tus sueños y aspiraciones son grandes, <br />por lo tanto mereces una
          institución que te respalde e impulse
        </h3>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="5"
        class="pa-0"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-img
          cover
          src="/images/imagenes/ventaja-quebuscas.jpg"
          height="85vh"
          width="100%"
        >
        </v-img>
      </v-col>
    </v-row>
    <v-row style="background-color: #2b2b2b" v-if="$vuetify.breakpoint.smAndUp">
      <v-col class="py-8" cols="12" sm="4" md="3" offset-md="1">
        <v-row class="mx-0">
          <v-col cols="12" sm="12" md="2">
            <v-icon size="40" color="white"> mdi-web </v-icon>
          </v-col>
          <v-col cols="12" sm="12" md="10">
            <h5 class="font-weight-regular white--text">
              EDUCACIÓN PARA <br />EL MUNDO REAL
            </h5>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="py-8" cols="12" sm="4" md="3" offset-md="1">
        <v-row class="mx-0">
          <v-col cols="12" sm="12" md="2">
            <v-icon size="40" color="white"> mdi-magnify </v-icon>
          </v-col>
          <v-col cols="12" sm="12" md="10">
            <h5 class="font-weight-regular white--text">
              INVESTIGACIÓN <br />
              PARA RESOLVER
            </h5>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="py-8" cols="12" sm="4" md="3" offset-md="1">
        <v-row class="mx-0">
          <v-col cols="12" sm="12" md="2">
            <v-icon size="40" color="white"> mdi-school </v-icon>
          </v-col>
          <v-col cols="12" sm="12" md="10">
            <h5 class="font-weight-regular white--text">
              VOCACIÓN <br />VIZCAYA
            </h5>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="py-12 bg-image d-flex justify-center align-center flex-column"
      :style="bgPrincipal"
    >
      <v-col
        cols="12"
        md="6"
        lg="6"
        xl="6"
        class="d-flex justify-center align-center flex-column"
      >
        <h1
          class="white--text font-weight-medium text-center"
          style="z-index: 2"
        >
          32 CAMPUS + 1 CAMPUS VIRTUAL
        </h1>
        <br />
        <h3
          v-if="$vuetify.breakpoint.smAndUp"
          class="white--text text-center"
          style="z-index: 2"
        >
          Contribuimos al desarrollo de las regiones fomentando la educación y
          cultura en sus diversas expresiones, formando profesionales
          competitivos, exitosos y leales, comprometidos con la excelencia, como
          manifestación de superación personal.
        </h3>
        <router-link to="/" style="text-decoration: none; padding-bottom: 10px">
          <v-btn
            depressed
            rounded
            light
            outlined
            color="white"
            lg
            class="my-4"
            style="z-index: 2"
          >
            Conócenos
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-row class="uval d-flex justify-center align-center flex-column">
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          class="py-5 d-flex justify-center align-center flex-column"
        >
          <h1 class="white--text text-center mt-12 mb-4">Diplomados</h1>
          <router-link
            to="/diplomado"
            style="text-decoration: none; padding-bottom: 10px"
          >
            <v-btn class="mb-12" outlined rounded depressed lg color="white">
              Conoce más
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
      <v-row class="uval d-flex justify-center align-center flex-column">
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          class="py-5 d-flex justify-center align-center flex-column"
        >
          <h1 class="white--text text-center mt-12 mb-4">Sistema Vizcaya</h1>
          <router-link
            to="/sistema"
            style="text-decoration: none; padding-bottom: 10px"
          >
            <v-btn class="mb-12" outlined rounded depressed lg color="white">
              Conoce más
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-row>
    <v-row>
      <v-col cols="12" md="7">
        <FAQ :titlecol="8" :questionscol="12" />
      </v-col>
      <v-col cols="12" md="5">
        <ContactFloat
          data-aos="fade-in"
          id="contact"
          :isMovil="$vuetify.breakpoint.mdAndUp ? false : true"
          :class="$vuetify.breakpoint.mdAndDown ? '' : 'mt-10'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss" scoped>
.bg-image {
  background-position: center;
  background-size: cover;
  height: 60vh;
  position: relative;
}
.bg-image::after {
  background-color: #122240;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.floating {
  z-index: 6 !important;
  cursor: pointer !important;
  position: fixed !important;
  overflow: hidden !important;
  right: 60px;
  bottom: 20px;
}
</style>
<script>
import { mapState } from "vuex";
import ContactFloat from "@/components/ContactFloat.vue";
import FAQ from "@/components/FAQ.vue";
export default {
  components: {
    ContactFloat,
    FAQ,
  },
  mounted() {
    gtag("event", "conversion", {
      send_to: "AW-739642856/3J_xCKf-j8UBEOib2OAC",
      event_callback: () => {
        console.log("uvaonline-home-btn-informate");
      },
    });
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    rvoe: null,
    type: "",
    image: "/mdAndDown-2021.jpg",
    url: "",
    carreer: "",
    namecarrer: "",
    logo: "",
    video: "",
    duration: "",
    initial_date: "",
    sliders: [],
    isOnline: false,
    carreerDescription: "",
    options: [],
    modalidad: [],
    location: "",
    constar: "",
    ingreso: [],
    egreso_text: "",
    egreso_list: [],
    btn_link: "",
    the_password: null,
    laboral: null,
    dialogPassword: false,
  }),
  computed: {
    ...mapState({}),
    bgPrincipal() {
      return {
        "background-image": "url('images/imagenes/blog2.jpg')",
      };
    },
  },
  methods: {},
  watch: {},
};
</script>
